import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from "react";
import { ChipSet, Chip } from "@material/react-chips";
import "@material/react-chips/dist/chips.css";
import "./ChipGroup.css";
import { Chip as ViewChip } from "../../"; // import Tooltip from '@material-ui/core/Tooltip';
// import Fade from '@material-ui/core/Fade';

import { InputLabel, makeStyles } from "../../";
var useStyles = makeStyles(function (theme) {
  return {
    formControl: {
      margin: "20px 0px"
    },
    chip: {
      "font-family": "Montserrat"
    },
    selected: {
      width: "40%",
      "background-color": "#33ff99 !important",
      color: "black !important"
    }
  };
});

var ChipGroup = function ChipGroup(_ref) {
  var value = _ref.value,
      options = _ref.options,
      form = _ref.form,
      fillForm = _ref.fillForm,
      field = _ref.field,
      isMulti = _ref.isMulti,
      clickable = _ref.clickable,
      props = _objectWithoutProperties(_ref, ["value", "options", "form", "fillForm", "field", "isMulti", "clickable"]);

  var _useState = useState([value]),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var classes = useStyles(); // console.log('value en chipgroup', value)
  // console.log('clickable en chipgroup', clickable)
  // console.log('options en chipgroup', options)

  useEffect(function () {
    field.name === "statusSells" ? setSelected(value.toString()) : setSelected(value);
  }, [field.name, value]); // const setValue = (options) => {
  // 	if (isMulti) {
  // 		if (options) {
  // 			return options.map((item) => {
  // 				return item.value;
  // 			});
  // 		}
  // 	} else return options.value;
  // };

  var onChange = function onChange(selectedChip) {
    // console.log("selectedChip", selectedChip);
    form.setFieldValue(field.name, field.name === "statusSells" ? parseInt(selectedChip) : selectedChip);

    if (fillForm) {
      fillForm(options.value);
    }
  };

  var handleSelect = function handleSelect(selectedChipIds) {
    // console.log("selectedChipIds", selectedChipIds);
    setSelected(selectedChipIds);
    onChange(selectedChipIds[0]);
  };

  return [/*#__PURE__*/React.createElement(InputLabel, {
    className: classes.formControl
  }, props.label), clickable ? /*#__PURE__*/React.createElement(ChipSet, {
    key: field.name,
    choice: true,
    selectedChipIds: selected,
    handleSelect: handleSelect
  }, options && options.map(function (option) {
    if (option.value === 0) {
      return /*#__PURE__*/React.createElement(Chip, {
        className: classes.chip,
        title: option.tooltip,
        key: option.value,
        id: "0",
        label: option.label
      });
    } else return /*#__PURE__*/React.createElement(Chip, {
      title: option.tooltip,
      className: classes.chip,
      key: option.value,
      id: option.value,
      label: option.label
    });
  })) : options && options.map(function (option) {
    if (option.value === selected) {
      // console.log('slected', selected)
      return /*#__PURE__*/React.createElement(ViewChip, {
        className: classes.selected,
        key: option.value,
        label: option.label,
        disabled: true
      });
    } else return null;
  })];
};

export { ChipGroup };